import { createStore } from 'redux';

const reducer = (state = {}, action) => {
  if (!action) {
    return state;
  }

  switch (action.type) {
    case 'UPDATE_EXCHANGE_RATE':
      {
        const {
          currency,
          price,
          updatedAt
        } = action.payload;
        return { ...state,
          [currency]: {
            price,
            updatedAt
          }
        };
      }

    case 'CLEAR_EXCHANGE_RATE':
      {
        const {
          currency
        } = action.payload;
        return { ...state,
          [currency]: undefined
        };
      }

    case 'CLEAR_ALL_EXCHANGE_RATE':
      {
        return {};
      }

    default:
      {
        return state;
      }
  }
};

export default createStore(reducer);